// Standalone campaign type values. Kept dependency-free and separate from
// templates.js so campaign/constants.js can import it without creating the
// templates.js <-> constants.js import cycle (templates.js imports from
// constants.js, and constants.js needs these type values).
export const campaignTypes = {
  default: 'default',
  giveNow: 'givenow',
  appeal: 'appeal',
  bespoke: 'bespoke',
  inMemory: 'inmemory',
  celebration: 'celebration',
  challenge: 'challenge',
  cycling: 'cycling',
  running: 'running',
  event: 'event',
  custom: 'custom'
};
